import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PlatformService } from "../platform/platform.service";
import { GlobalConstants } from "@src/app/global-constants";
import { Observable } from "rxjs";

@Injectable()
export class AlbumsService {
  private readonly API_URL: any;
  private readonly API_SHARED_URL: any;
  private readonly constantesGlobales: any;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    this.constantesGlobales = new GlobalConstants(host);
    this.API_URL = this.constantesGlobales.urlApi;
    this.API_SHARED_URL = this.constantesGlobales.urlSharedApi;
  }

  /**
   * Obtiene una lista de álbumes desde el servidor.
   *
   * @param idAmbito - El identificador del ámbito para filtrar los álbumes.
   * @param id - (Opcional) El identificador específico de un álbum.
   * @param limit - (Opcional) Límite de resultados a obtener.
   * @param is_video - (Opcional) Indica si se deben obtener álbumes de videos.
   * @returns Un observable que emite la respuesta del servidor con la lista de álbumes.
   */
  public getAlbums(idAmbito: number, id: number = null, limit: number = null, is_video: boolean = false): Observable<any> {
    if (id !== null && isNaN(id)) return;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });

    let body = new HttpParams().set("id_ambito", String(idAmbito));
    if (id !== null) {
      body = body.set("id", String(id));
    }
    if (limit !== null) {
      body = body.set("limit", String(limit));
    }
    body = body.set("is_video", String(is_video));

    return this.httpClient.get(this.API_URL + "/getAlbums", { headers: headers, params: body });
  }
}
